import { userPaths } from 'routes/constants/userPaths';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import {
  FROM_END_USER_DASHBOARD_STATE_KEY,
  FROM_NO_EXPENSE_FOUND_STATE_KEY,
} from 'components/onboardingLayout';

import { useEndUserDashboardAccess } from 'hooks/useEndUserDashboardAccess';
import { useTpaStreamAnalyticsAbandonment } from 'hooks/useTpaStreamAnalyticsAbandonment';

import { isEndUserTpaFlowActive } from 'utils/endUserTpaFlowStorage';

import { resolveOnboardingFindExpensesConnectedRedirect } from './onboardingFindExpensesConnectedRedirect.data';

/** Blocks find-expenses while account connection is pending or failed. */
const EndUserTpaConnectionRoute = () => {
  useTpaStreamAnalyticsAbandonment();
  const location = useLocation();
  const { isLoading, canAccessTpaConnectionFlow, accountState, profileState, hasExpenses } =
    useEndUserDashboardAccess();
  const isDashboardTpaFlow = isEndUserTpaFlowActive();
  const locationState = location.state as Record<string, unknown> | null;
  const fromNoExpenseFound = locationState?.[FROM_NO_EXPENSE_FOUND_STATE_KEY] === true;
  const fromEndUserDashboard = locationState?.[FROM_END_USER_DASHBOARD_STATE_KEY] === true;
  const isIntentionalFindExpensesReentry =
    isDashboardTpaFlow || fromNoExpenseFound || fromEndUserDashboard;

  if (isLoading) {
    return null;
  }

  if (!canAccessTpaConnectionFlow && !isDashboardTpaFlow) {
    return <Navigate to={userPaths.endUser} replace />;
  }

  const connectedOnboardingRedirect = resolveOnboardingFindExpensesConnectedRedirect({
    accountState,
    profileState,
    hasExpenses,
    isIntentionalFindExpensesReentry,
  });

  if (connectedOnboardingRedirect != null) {
    return <Navigate to={connectedOnboardingRedirect} replace />;
  }

  return <Outlet />;
};

export default EndUserTpaConnectionRoute;
